import { Role } from './role';

export class CurrentUser {
	public email = '';
	public role: Role = Role.None;
	public userId = '';
}
